import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function ArrowUp({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M12.7072 4.29289L18.7072 10.2929L17.2929 11.7071L13 7.41421L13 20H11L11 7.41421L6.70715 11.7071L5.29294 10.2929L11.2929 4.29289C11.6835 3.90237 12.3166 3.90237 12.7072 4.29289Z"
        fill={iconColor}
      />
    </Svg>
  );
}
